import { render, staticRenderFns } from "./cargoTemplateSelectorDialog.vue?vue&type=template&id=c3379948&"
import script from "./cargoTemplateSelectorDialog.vue?vue&type=script&lang=js&"
export * from "./cargoTemplateSelectorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3379948')) {
      api.createRecord('c3379948', component.options)
    } else {
      api.reload('c3379948', component.options)
    }
    module.hot.accept("./cargoTemplateSelectorDialog.vue?vue&type=template&id=c3379948&", function () {
      api.rerender('c3379948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoTemplateSelectorDialog.vue"
export default component.exports